import { fetchCustomerData } from '../api';
import { GetCustomerAPIDataType } from '../types';

import useFetch from './useFetch';

type UseCustomerDataReturn = {
  customerData: GetCustomerAPIDataType | null;
  isLoading: boolean;
  error: string | null;
};

/**
 * Hook for fetching customer data by phone number.
 * Handles the common pattern of conditionally fetching customer data.
 */
const useCustomerData = (phoneNumber: string | undefined): UseCustomerDataReturn => {
  const { data, isLoading, error } = useFetch<GetCustomerAPIDataType | null>(
    () =>
      (phoneNumber ?
        (fetchCustomerData(phoneNumber) as Promise<GetCustomerAPIDataType>) :
        Promise.resolve(null)),
    [phoneNumber],
  );

  return {
    customerData: data,
    isLoading,
    error,
  };
};

export default useCustomerData;
